import { useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";
import { ArrowLeft, Loader2, MailCheck, KeyRound } from "lucide-react";
import { Input } from "@/components/ui/input";
import { API_BASE } from "@/lib/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!/^\S+@\S+\.\S+$/.test(email)) return toast.error("Please enter a valid email.");
    setLoading(true);
    try {
      await axios.post(`${API_BASE}/member/auth/forgot-password`, { email: email.trim() });
      setSent(true);
    } catch {
      toast.error("Something went wrong — please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#F7F5F0] text-[#2D372B]">
      <div className="max-w-md mx-auto px-6 pt-16 pb-20">
        <Link to="/login" className="inline-flex items-center gap-2 text-sm text-[#5C665A] hover:text-[#2D372B]" data-testid="back-to-login">
          <ArrowLeft size={15} /> Back to login
        </Link>
        <div className="mt-8 flex items-center gap-3">
          <div className="w-12 h-12 rounded-full bg-[#89937C]/20 flex items-center justify-center"><KeyRound size={20} className="text-[#5C665A]" /></div>
          <h1 className="font-serif-display text-3xl">Forgot password</h1>
        </div>
        <p className="text-[#5C665A] mt-3 mb-8 text-sm">Enter your account email and we'll send you a link to set a new password.</p>
        {sent ? (
          <div className="bg-white border-2 border-[#89937C] rounded-3xl p-7" data-testid="forgot-sent">
            <MailCheck size={22} className="text-[#5C665A]" />
            <div className="font-semibold mt-3">Check your email</div>
            <p className="text-sm text-[#5C665A] mt-1">
              If an account exists for <span className="font-medium text-[#2D372B]">{email}</span>, a reset link is on its way (valid 1 hour). Don't forget the spam folder.
            </p>
            <Link to="/login" className="mt-5 inline-flex rounded-full px-6 py-2.5 bg-[#2D372B] text-white text-sm font-medium hover:bg-[#89937C] transition-colors">Back to login</Link>
          </div>
        ) : (
          <form onSubmit={submit} className="bg-white border border-[#E5E2D9] rounded-3xl p-7 space-y-4">
            <Input data-testid="forgot-email-input" type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Your account email" className="bg-[#F7F5F0] border-[#E5E2D9] h-12" />
            <button data-testid="forgot-submit-btn" type="submit" disabled={loading}
              className="w-full inline-flex items-center justify-center gap-2 rounded-full px-6 py-3 bg-[#2D372B] text-white font-medium hover:bg-[#89937C] transition-colors disabled:opacity-60">
              {loading && <Loader2 size={14} className="animate-spin" />} Email me a reset link
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
